export enum CurrencyCodes {
	NAIRA = "&#8358;",
}
